import React, { useState } from 'react';
import {
  Autocomplete, Button, Grid2, Grid,
  TextField, Table, TableContainer, TableRow,
  TableBody, TableHead, InputAdornment
} from '@mui/material';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';
import { createFilterOptions } from "@mui/material/Autocomplete";
import { CreditorService } from '../../services/creditorService';

const formatter = new Intl.NumberFormat("es-CL"); // formato CLP (Chile)

const FormularioAcreedor = ({ servicio, acreedoresSistema, agregarAcreedorServicio, indice }) => {

  const filter = createFilterOptions();

  const [acreedorSeleccionado, setAcreedorSeleccionado] = useState(null);

  // 🔒 bloqueo por estados del contrato
  const contratoCancelado = useSelector((s) => s.contratoV2.ContratoCancelado);
  const contratoFiniquitado = useSelector((s) => s.contratoV2.ContratoFiniquitado);
  const contratoFirmado = useSelector((s) => s.contratoV2.ContratoFirmado);
  const actualizacion = useSelector((store) => store.contratoV2.Actualizacion)

  //const [disabledComponent, setDisabledComponent] = useState(false);

  const disabledComponent = actualizacion?.actualizacion?.status == 1

  const bloqueadoTotalmente =
    !!contratoCancelado?.cancelado ||
    !!contratoFiniquitado?.finiquitado || (contratoFirmado?.firmado && !disabledComponent)

  const onClick = (idService) => {
    if (bloqueadoTotalmente) return; // 🔒 no permitir acciones
    if (checkErrors()) return;
    const aux = { ...acreedorSeleccionado, id: 0 };
    agregarAcreedorServicio(idService, aux);
    setAcreedorSeleccionado(null);
  };

  const checkErrors = () => {
    let error = false;
    let title = "";
    let text = "";
    if (acreedorSeleccionado == null) {
      error = true;
      title = "Falta  acreedor";
      text = "No ha seleccionado un acreedor";
    }
    else if (acreedorSeleccionado.monto == null) {
      error = true;
      title = "Falta  monto";
      text = "No ha asignado un monto al acreedor";
    }
    if (error) Swal.fire({ icon: "warning", title, text, });
    return error;
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        {/*<Autocomplete
          options={acreedoresSistema}
          getOptionLabel={(option) => option.name ?? ""}
          value={acreedorSeleccionado}
          onChange={(event, newValue) => {
            if (bloqueadoTotalmente) return; // 🔒
            setAcreedorSeleccionado(newValue);
          }}
          disabled={bloqueadoTotalmente} // 🔒
          renderOption={(props, option) => (
            <li {...props} key={option.id}>
              {option.name}
            </li>
          )}
          renderInput={(params, index) => (
            <TextField
              isOptionEqualToValue={(o, v) => o?.id === v?.id}
              {...params}
              label="Selecciona acreedor"
              placeholder="Buscar..."
              fullWidth
              disabled={bloqueadoTotalmente} // 🔒
            />
          )}
        />*/}
        <Autocomplete
          freeSolo
          options={acreedoresSistema}
          getOptionLabel={(option) =>
            typeof option === "string" ? option : option.name ?? ""
          }
          value={acreedorSeleccionado}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);
            const inputValue = params.inputValue.trim();

            // Si no hay resultados y hay texto → agregar opción especial
            if (inputValue !== "" && filtered.length === 0) {
              filtered.push({
                id: -1,
                name: `➕ Incluir acreedor nuevo: "${inputValue}"`,
                inputValue,
                isAddNew: true,
              });
            }

            return filtered;
          }}
          onChange={async (event, newValue) => {
            if (bloqueadoTotalmente) return;

            // Caso 1: Selección normal
            if (!newValue?.isAddNew) {
              setAcreedorSeleccionado(newValue);
              return;
            }

            // Caso 2: Crear nuevo acreedor en BD
            const texto = newValue.inputValue;

            try {
              var id = await CreditorService.AddCreditor(texto);
              const creado = {
                "id": id,
                "name": texto,
                "idStatus": 1,
                "monto": null,
                "detalle": null
              };

              setAcreedorSeleccionado(creado);
            } catch (err) {
              console.error(err);
            }
          }}
          renderOption={(props, option) => (
            <li {...props} key={option.id}>
              {option.name}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Selecciona acreedor"
              placeholder="Buscar..."
              fullWidth
              disabled={bloqueadoTotalmente}
            />
          )}
        />
        {/******/}

      </Grid>

      <Grid item xs={12} sm={2}>
        <TextField
          fullWidth
          label="Monto acreedor"
          value={
            acreedorSeleccionado?.monto || acreedorSeleccionado?.monto === 0
              ? formatter.format(acreedorSeleccionado.monto)
              : ""
          }
          onChange={(e) => {
            if (bloqueadoTotalmente) return; // 🔒
            const soloNumeros = e.target.value.replace(/\D/g, "");
            setAcreedorSeleccionado((prev) => ({
              ...prev,
              monto: soloNumeros ? Number(soloNumeros) : 0,
            }));
          }}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
            inputMode: "numeric",
            pattern: "[0-9]*",
            readOnly: bloqueadoTotalmente, // 🔒
          }}
          disabled={bloqueadoTotalmente} // 🔒
          error={
            acreedorSeleccionado != null &&
            (acreedorSeleccionado?.monto < 0 || isNaN(acreedorSeleccionado?.monto))
          }
          helperText={
            acreedorSeleccionado?.monto < 0 || isNaN(acreedorSeleccionado?.monto)
              ? "Ingrese un monto válido"
              : ""
          }
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Detalle"
          value={acreedorSeleccionado?.detalle ?? ""}
          onChange={(e) => {
            if (bloqueadoTotalmente) return; // 🔒
            const value = e.target.value.slice(0, 500); // fuerza el límite
            setAcreedorSeleccionado((prev) => ({ ...prev, detalle: value }));
          }}
          disabled={bloqueadoTotalmente} // 🔒
          inputProps={{ maxLength: 500 }}
        />
      </Grid>

      <Grid item xs={12} sm={2}>
        <Button
          type="button"
          variant="contained"
          color="primary"
          onClick={() => onClick(servicio.idService)}
          disabled={bloqueadoTotalmente} // 🔒
        >
          Agregar Acreedor
        </Button>
      </Grid>
    </Grid>
  );
};

export default FormularioAcreedor;
